<template>
  <svg
    :width="size"
    :height="(size * 20) / 21"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.3788 11.6128L15.5 14.596M15.5 14.596V19.5M15.5 14.596L10.5 11.5387M15.3727 3.46002L10.5 6.43702M5.62727 3.46619L10.5 6.44319V11.5387M5.5 14.596V19.5M5.5 14.596L0.621212 11.6128M5.5 14.596L10.5 11.5387M10.5 11.5387V16.4118M10.5 11.5387L5.5 8.25904L0.954545 11.236C0.669697 11.4275 0.5 11.7487 0.5 12.0946V15.856C0.5 16.208 0.675758 16.5292 0.960606 16.7145L4.96061 19.3332C5.29394 19.5494 5.71818 19.5494 6.04545 19.3332L10.5 16.4118M10.5 11.5387L15.5 8.25904L20.0455 11.236C20.3303 11.4275 20.5 11.7487 20.5 12.0946V15.856C20.5 16.2018 20.3303 16.523 20.0455 16.7145L16.0455 19.3332C15.7182 19.5494 15.2939 19.5494 14.9606 19.3332L10.5 16.4118M15.0152 3.08943C15.3182 3.27473 15.5 3.60825 15.5 3.96648V8.26522L10.5 11.5449L5.5 8.26522V3.96648C5.5 3.60825 5.68182 3.27473 5.98485 3.08943L9.98485 0.6436C10.3 0.452133 10.7 0.452133 11.0152 0.6436L15.0152 3.08943Z"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number;
    color?: string;
  }>(),
  {
    size: 37,
    color: "#D0A444",
  },
);
</script>
